import { graphql } from '@/gql';
import type { PaginationInputType, PartnerUserFilterInputType } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchPartnerUsers = async (filter: PartnerUserFilterInputType, pagination: PaginationInputType) => {
  const response = await queryExecute({
    variables: {
      filter,
      pagination,
    },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query partnerUsers($filter: PartnerUserFilterInputType, $pagination: PaginationInputType) {
        partnerUsers(filter: $filter, pagination: $pagination) {
          count
          rows {
            id
            firstName
            lastName
            email
            roles
          }
        }
      }
    `),
  });

  return response.data.partnerUsers;
};
